import React from "react";
import PickActions from "../../../PickActions/PickActions";
import BarcodeModalButton from "../../../buttons/BarcodeModalButton";
import BarcodeScanner from "../../../BarcodeInput/BarcodeScanner";
import { useBarcodeScanner } from "../../../../../hooks/useBarcodeScanner";
import CancelOrderButton from "../../../buttons/CancelOrderButton";
import ConfirmBoxButton from "../../../buttons/ConfirmBoxButton";
import { Button } from "semantic-ui-react";

type Props = {
  scannedItemId: number | null;
  isAllRestocked: boolean;
  onScanShelf: any;
  onScanItem: any;
  onOperatorConfirmFinish: () => void;
};

const RestockActions = ({
  isAllRestocked,
  scannedItemId,
  onScanShelf,
  onScanItem,
  onOperatorConfirmFinish,
}: Props) => {
  const { onExecuteHigherOrderHandlerOrDefault } = useBarcodeScanner();
  return (
    <PickActions>
      {scannedItemId ? (
        <>
          <BarcodeModalButton
            onBarcodeScanAsync={onScanShelf}
            title="Ange hyllplats"
            textFieldLabel="Hyllplats"
          />
          <BarcodeScanner
            onScan={(barcode, format) =>
              onExecuteHigherOrderHandlerOrDefault(barcode, format, onScanShelf)
            }
          />
        </>
      ) : (
        <>
          <BarcodeModalButton
            onBarcodeScanAsync={onScanItem}
            title="Ange varunummer"
            textFieldLabel="Varunummer"
          />

          <BarcodeScanner
            onScan={(barcode, format) =>
              onExecuteHigherOrderHandlerOrDefault(barcode, format, onScanItem)
            }
          />
        </>
      )}
      {/* <CancelOrderButton /> */}
      <Button
        style={{ gridColumn: "1 / -1" }}
        content="OK"
        size="big"
        color="green"
        aria-label="OK"
        icon="check"
        onClick={onOperatorConfirmFinish}
        disabled={!isAllRestocked}
      />
    </PickActions>
  );
};

export default RestockActions;
